import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { BlankLayoutModule } from '@app/layout/blank-layout';
import {
  ContentSelectDialogModule
} from '@app/shared/components/dialogs/content-select/content-select-dialog.module';
import {
  DocumentPreviewDialogModule
} from '@app/shared/components/dialogs/document-preview/document-preview-dialog.module';
import {
  DocumentSearchDialogModule
} from '@app/shared/components/dialogs/document-search/document-search.dialog.module';
import { FlowMaterialModule } from '@app/flow-material.module';
import { FroalaModule } from '@component/froala-editor';
import { ModalModule } from '@component/modal';
import { RenderedFormModule } from '@app/shared/components/rendered-form/rendered-form.module';
import { RichtextEditorModule } from '@app/shared/components/richtext-editor/richtext-editor.module';
import { StepperModule } from '@app/shared/components/stepper/stepper.module';
import { UIComponentsModule } from '@app/shared/components/ui-components.module';
import {
  VariableCreateDialogModule
} from '@app/shared/components/dialogs/variable-create/variable-create-dialog.module';

import { AuthenticatedComponent } from './authenticated.component';
import { AuthenticatedRoutingModule } from './authenticated-routing.module';
import { EditorViewComponent } from './editor-view/editor-view.component';
import { PreviewFormComponent } from './preview-form/preview-form.component';
import { ShareWizardComponent } from './share-wizard/share-wizard.component';
import { TestDataModalComponent } from './preview-form/test-data-modal';
import { ViewDocumentComponent } from './view-document/view-document.component';


@NgModule({
    declarations: [
        AuthenticatedComponent,
        EditorViewComponent,
        PreviewFormComponent,
        ShareWizardComponent,
        ViewDocumentComponent,
        TestDataModalComponent
    ],
    imports: [
        AuthenticatedRoutingModule,
        CommonModule,
        ContentSelectDialogModule,
        DocumentPreviewDialogModule,
        DocumentSearchDialogModule,
        FlowMaterialModule,
        BlankLayoutModule,
        FormsModule,
        FroalaModule,
        ReactiveFormsModule,
        RenderedFormModule,
        RichtextEditorModule,
        StepperModule,
        UIComponentsModule,
        VariableCreateDialogModule,
        ModalModule
    ]
})
export class AuthenticatedModule {}
